export { default } from './CircularProgress';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/CircularProgress/index.js
// module id = 128
// module chunks = 0